<p class="tooltip-list-title">Password must:</p>
<ul class="password-requirement-list">
  @for (requirement of passwordRequirements; track requirement) {
    <li>
      {{requirement}}
    </li>
  }
</ul>